import type { IntlShape } from 'react-intl'
import { TOOL_NAME } from 'tripPlanner/api/types'
import { getChatToolLoadingMessageDescriptor, isChatToolLoadingKey } from 'tripPlanner/config/chatToolLoading'

export function formatToolCallLabel(
  tool: string,
  args: Record<string, unknown>,
  intl: IntlShape,
): string {
  const query = typeof args.naturalLanguageQuery === 'string' ? args.naturalLanguageQuery : ''
  if (query && (tool === TOOL_NAME.SEARCH_HOTELS || tool === TOOL_NAME.SEARCH_EXPERIENCES)) {
    return intl.formatMessage({
      id: '4x3gtrCChrckbzhvgwBj',
      defaultMessage: 'Searching for {query}…',
      description: 'Loading label while the assistant searches hotels or experiences using the supplied search query',
    }, { query })
  }
  if (isChatToolLoadingKey(tool)) {
    return intl.formatMessage(getChatToolLoadingMessageDescriptor(tool))
  }
  return intl.formatMessage({
    id: '6c5xn35ovrdi7Qqa22_o',
    defaultMessage: 'Working on it…',
    description: 'Generic loading label when AI is executing an unknown tool in trip planner chat',
  })
}
